import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const GamesPage = lazy(() => import('../pages/games/page'));
const HowToPlayPage = lazy(() => import('../pages/how-to-play/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/games',
    element: <GamesPage />,
  },
  {
    path: '/how-to-play',
    element: <HowToPlayPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
